<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
        el-col.pt-5.text-right(:span="15")
          el-button(type="primary" size="mini" :loading="loading" @click="exportData") 导出
          el-button(type="primary" size="mini" @click="$router.go(-1)") 返回
    div(style="height:50px")
    el-main.white.pa-3.ma-4
      div
        el-row.py-3(type="flex" justify="center")
          el-col(:span="22")
            el-row(type="flex"  :gutter="10")
              el-col(:span="6")
                el-select.w-100(v-model="list.stock_org_code" :filter-method="sourcestockorg" filterable placeholder="闲置组织" clearable)
                  el-option(v-for="item in stockorg" :key="item.code" :label="item.name" :value="item.code")
              el-col(:span="6")
                el-input.w-100(v-model="list.mater_name" placeholder="物料名称" clearable)
              el-col(:span="6")
                el-input.w-100(v-model="list.mater_code" placeholder="物料编码" clearable)
              el-col(:span="6")
                el-date-picker.w-120(v-model="time" type="daterange" align="right" unlink-panels range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions1")
              el-col(:span="6")
                el-select.w-120(v-model="list.busi_type" filterable clearable placeholder="请选择业务类型")
                  el-option(v-for="item in xzwzlx" :key="item.code" :label="item.name" :value="item.code")
        el-row.py-1(type="flex" justify="center")
          el-col(:span="12")
            el-row(type="flex" justify="center")
              el-col(:span="10")
                el-button(type="primary" @click="getList" :loading="loading") 查询
                el-button(@click="clear") 清空
      el-table(:data="data" height="460" v-loading="loading" row-key="id" size="mini" @selection-change="handleSelectionChange" tooltip-effect="dark")
        el-table-column(prop="stock_org_name" label="闲置组织" width="220" key="stock_org_name" show-overflow-tooltip)
        el-table-column(prop="mater_class_name" label="分类" width="100" key="mater_class_name" show-overflow-tooltip)
        el-table-column(prop="mater_code" label="物料编码" width="120" key="mater_code")
        el-table-column(prop="mater_name" label="物料名称" width="200" key="mater_name" show-overflow-tooltip)
        el-table-column(prop="mater_unit_name" label="单位" width="100" key="mater_unit_name" show-overflow-tooltip)
        el-table-column(prop="busi_type_name" label="业务类型" width="120" key="busi_type_name" show-overflow-tooltip)
        el-table-column(prop="create_date" label="创建日期" width="200" key="create_date" show-overflow-tooltip)
        el-table-column(prop="person_name" label="联系人" width="120" key="person_name" show-overflow-tooltip)
        el-table-column(prop="handle_type_name" label="处置方式" width="120" key="handle_type_name" show-overflow-tooltip)
        el-table-column(prop="book_num" label="数量" width="120" key="book_num" show-overflow-tooltip)
        el-table-column(prop="book_price" label="账面单价" width="120" key="book_price" show-overflow-tooltip)
        el-table-column(prop="book_money" label="账面金额" width="120" key="book_money" show-overflow-tooltip)
        el-table-column(prop="handle_money" label="处置无税金额" width="120" key="handle_money" show-overflow-tooltip)
        el-table-column(prop="handle_income" label="处置收益" width="120" key="handle_income" show-overflow-tooltip)
        el-table-column(prop="creator_name" label="创建人" width="120" key="creator_name" show-overflow-tooltip)
        el-table-column(prop="remark" label="备注" width="120" key="remark" show-overflow-tooltip)
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)
</template>
<script>
import { url } from "@/utils/config";
import qs from "qs";
export default {
  data() {
    return {
      flag: false,
      url: url,
      h: "",
      loading: false,
      dialogFormVisible: false,
      rules: {
        pk_org: [{ required: true, message: "请选择公司", trigger: "change" }],
        pk_psndoc: [
          { required: true, message: "请选择采购员", trigger: "change" },
        ],
        reason: [{ required: true, message: "请填写原因", trigger: "blur" }],
        itemName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        bidType: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        bid_type: [
          { required: true, message: "请选择科目类别", trigger: "change" },
        ],
        bidDuration: [
          { pattern:  /^[0-9]\d*$/, message: '只支持整数', trigger: 'blur' },
        ],
        delayedTime: [
          { pattern:  /^[0-9]\d*$/, message: '只支持整数', trigger: 'blur' },
        ],
      },
      activeName: "first",
      disabled: false,
      list: {
        id:this.$route.params.id,
        mater_name: null,
        mater_code: null,
        stock_org_code: null,
        assign_date: null,
        create_date: null,
        class_material: null,
        code: null,
        is_urgent: null,
        key_name: null,
        page_num: 1,
        page_size: 100,
        start_date: null,
        end_date: null,
        busi_type: null,
        type: 1
      },
      classify: [],
      count: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      list1: {
        page_num: 1,
        page_size: 100,
      },
      list2: {
        page_num: 1,
        page_size: 100,
      },
      list3: {
        page_num: 1,
        page_size: 100,
      },
      list4: {
        page_num: 1,
        page_size: 100,
      },
      list5: {
        page_num: 1,
        page_size: 100,
      },
      data: [],
      multipleSelection: [],
      dialogFormBuyOrg: false,
      formBuyOrg: {
        pk_org: "",
      },
      dialogFormBuyPerson: false,
      formBuyPerson: {
        pk_psndoc: "",
      },
      dialogFormBid: false,
      formBid: {
        bid_type: null,
        offerEndtime: "",
        openTime: "",
        signupEnddate: "",
        ootEnddate: "",
        beginTime: "",
        bidDuration:"0",
        delayedTime:"0",
      },
      person: [],
      loadingPerson: false,
      dialogFormBack: false,
      formBack: {
        id: [],
        reason: "",
      },
      pics: [],
      dialogPic: false,
      path: this.$api.purchase_idle_goods.import_file,
      bid_type: [],
      loadingSupply: false,
      supply: [],
      xzwzlx:[]
    };
  },
  computed:{
    time:{
      get: function () {
        if(this.list.start_date==null||this.list.end_date==null){
          return ''
        }else {
          return [this.list.start_date,this.list.end_date]
        }
      },
      set: function (val) {
        if(val==null){
          this.list.start_date=null;
          this.list.end_date=null;
        }
        this.list.start_date=val[0];
        this.list.end_date=val[1];
      }
    },
  },
  methods: {
    async getMaterialPic(code) {
      this.loadingn = true;
      let res = await this.$api.global.getMaterialPic(
        qs.stringify(
          {
            code_arr: [code],
          },
          { arrayFormat: "repeat" }
        )
      );
      this.loading = false;
      if (res) {
        this.pics = res.data;
        this.dialogPic = true;
      }
    },
    beforeUpload () {
      this.loading = true;
      return true;
    },
    handleSuccess (res) {
      this.loading = false;
      if (res.code == 200) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.getList();
      } else {
        this.$notify({
          message: res.msg,
          type: "error",
        });
      }
    },
    async submitFormBack() {
      this.$refs["formBack"].validate(async (valid) => {
        if (valid) {
          for (var i in this.multipleSelection) {
            this.formBack.id.push(this.multipleSelection[i].id);
          }
          this.loading = true;
          let res = await this.$api.purchase_demand.back(this.formBack);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.getList();
          }
        } else {
          return false;
        }
      });
    },
    async back() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }
      this.dialogFormBack = true;
      this.$nextTick(function () {
        this.$refs["formBack"].resetFields();
        this.formBack.id = [];
        this.formBack.reason = "";
      });
    },
    async exportData() {
      this.loading = true;
      await this.$api.purchase_idle_goods.getBlob(this.list);
      this.loading = false;
    },
    clear() {
      this.list.mater_name = null;
      this.list.mater_code = null;
      this.list.stock_org_code = null;
      this.list.assign_date = null;
      this.list.create_date = null;
      this.list.class_material = null;
      this.list.code = null;
      this.list.is_urgent = null;
      this.classify = [];
      this.list.buy_org_code = null;
      this.list.start_date = null;
      this.list.end_date = null;
      this.list.busi_type = null;
    },
    del(e) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.$api.purchase_demand.del(e);
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.getList();
          }
        })
        .catch(() => {});
    },
    gotoPlaceOrder() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }

      let data = [];
      for (var i in this.multipleSelection) {
        data.push(this.multipleSelection[i].id);
      }
      this.$router.push({
        path: "/purchase/place_an_order",
        query: { ids: data.toString() },
      });
    },
    async getPersonList(query) {
      if (!query) {
        return false;
      }
      this.loadingPerson = true;
      let res = await this.$api.global.personList({
        key_name: query,
        page_num: 1,
        page_size: 100,
      });
      this.loadingPerson = false;
      if (res) {
        this.person = res.data;
      }
    },
    setSourceBuyPerson() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }
      this.dialogFormBuyPerson = true;
    },
    changeBid(e) {
      this.formBid.bid_type = e;
      /*if (this.formBid.bid_type == "MY50") {
        this.formBid.offerEndtime= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
        this.formBid.openTime= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      }
      if (this.formBid.bid_type == "MY40") {
        this.formBid.signupEnddate= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
        this.formBid.ootEnddate= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      }
      if (this.formBid.bid_type == "MY52") {
        this.formBid.beginTime= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      }*/
    },
    bid() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }
      this.formBid.bid_type= "MY50",
      this.dialogFormBid = true;
      this.formBid.offerEndtime= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      this.formBid.openTime= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      this.formBid.signupEnddate= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      this.formBid.ootEnddate= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      this.formBid.beginTime= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
    },
    submitFormBid() {
      this.$refs["formBid"].validate(async (valid) => {
        if (valid) {
          let data=[];
          for (var i in this.multipleSelection) {
            data.push( this.multipleSelection[i] );
          }
          this.loading = true;
          let res = await this.$api.purchase_demand.bid({
            list: data,
            beginTime: this.formBid.beginTime,
            bidDuration: this.formBid.bidDuration,
            bid_type: this.formBid.bid_type,
            delayedTime: this.formBid.delayedTime,
            offerEndtime: this.formBid.offerEndtime,
            ootEnddate: this.formBid.ootEnddate,
            openTime: this.formBid.openTime,
            signupEnddate: this.formBid.signupEnddate,
            itemName: this.formBid.itemName,
            bidType: this.formBid.bidType,
          });
          this.loading = false;

          //let res = await this.$api.purchase_demand.bid(this.formBid);
          if (res) {
            this.dialogFormBid = false;
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
    submitFormBuyPerson() {
      this.$refs["formBuyPerson"].validate(async (valid) => {
        if (valid) {
          let data = [];
          for (var i in this.multipleSelection) {
            data.push({
              id: this.multipleSelection[i].id,
              source_buy_person: this.formBuyPerson.pk_psndoc,
            });
          }
          let res = await this.$api.purchase_demand.updateList(data);
          if (res) {
            this.dialogFormBuyPerson = false;
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
    setSourceBuyOrg() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要匹配的物料",
          type: "error",
        });
        return false;
      }
      this.dialogFormBuyOrg = true;
    },
    submitFormBuyOrg() {
      this.$refs["formBuyOrg"].validate(async (valid) => {
        if (valid) {
          let data = [];
          for (var i in this.multipleSelection) {
            data.push({
              id: this.multipleSelection[i].id,
              source_buy_org: this.formBuyOrg.pk_org,
            });
          }
          let res = await this.$api.purchase_demand.updateList(data);
          if (res) {
            this.dialogFormBuyOrg = false;
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
    async setPubState(type) {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择需要操作的数据",
          type: "error",
        });
        return false;
      }
      let data = [];
      for (var i in this.multipleSelection) {
        data.push({ id: this.multipleSelection[i].id, pub_state: type });
      }
      this.loading = true;
      let res = await this.$api.purchase_demand.updateList(data);
      this.loading = false;
      if (res) {
        this.getList();
        this.$notify({
          message: "操作成功",
          type: "success",
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search(type) {
      if (type == 2) {
        this.list.key_name = null;
      } else {
        this.list.mater_name = null;
        this.list.mater_code = null;
        this.list.stock_org_code = null;
        this.list.assign_date = null;
        this.list.create_date = null;
        this.list.class_material = null;
        this.list.code = null;
        this.list.is_urgent = null;
        this.list.buy_org_code = null;
      }
      let k = [];
      for (var i in this.classify) {
        k.push(this.classify[i][this.classify[i].length - 1]);
      }
      localStorage.setItem(
        "PurchaseDemand_class",
        JSON.stringify(this.classify)
      );
      this.list.class_material = k.toString();
      this.list.page_num = 1;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    async getList() {
      this.loading = true;
      let pam = {}
      for(let i in this.list){
        if(this.list[i]!==''){
          pam[i] = this.list[i]
        }
      }
      let res = await this.$api.purchase_idle_goods.getDataList(pam);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count =res.count
      }
    },
    async changeStatus(type,detail) {
      if(type==="stop"){
        await this.$confirm("此操作将停用该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              detail.state=1
            })
            .catch(() => {
              return
            });
      }else if(type==="delete"){
        await this.$confirm("此操作将删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              detail.dr=1
            })
            .catch(() => {
              return
            });

      } else if(type==="start"){
        await this.$confirm("此操作将启用该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              detail.state=0
            })
            .catch(() => {
              return
            });

      }
      this.loading = true;
      let res = await this.$api.purchase_idle_goods.update(detail);
      this.loading = false;
      if (res) {
        this.getList();
        this.$notify({
          message: "操作成功",
          type: "success",
        });
      }
    },
    init() {
      this.getList();
    },
    async getSupplyList(query) {
      if (!query) {
        return false;
      }
      localStorage.setItem("PurchaseOrder_query", query);
      this.loadingSupply = true;
      let res = await this.$api.supplier.getotherList({
        key_name: query,
        page_num: 1,
        page_size: 100,
        no_check: 1,
        checkstatus: 3,
      });
      this.loadingSupply = false;
      if (res) {
        this.supply = res.data;
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    if (
      this.$store.state.token &&
      JSON.stringify(this.$store.state.material_class) == "{}"
    )
      this.getMaterialClass();
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();
    if (this.$store.state.token && this.$store.state.stock_org == false)
      this.getStockOrg();
    this.getDefdoc(this, { code: "bid_type" });
    this.getDefdoc(this, { code: "xzwzlx" });
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>
